// Fill REACT_APP_GADS_SEND_TO (e.g. AW-123456789/AbC-dEfGh) and REACT_APP_GADS_ID to enable conversion tracking.
const SEND_TO = process.env.REACT_APP_GADS_SEND_TO;
const GADS_ID = process.env.REACT_APP_GADS_ID;

export function loadAdsTag() {
    if (!GADS_ID || window.gtag) return;
    const s = document.createElement("script");
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${GADS_ID}`;
    document.head.appendChild(s);
    window.dataLayer = window.dataLayer || [];
    window.gtag = function gtag() { window.dataLayer.push(arguments); };
    window.gtag("js", new Date());
    window.gtag("config", GADS_ID);
}

export function trackLeadConversion() {
    if (SEND_TO && window.gtag) window.gtag("event", "conversion", { send_to: SEND_TO });
}

export function readUtm() {
    const p = new URLSearchParams(window.location.search);
    const keys = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "gclid"];
    return Object.fromEntries(keys.filter((k) => p.get(k)).map((k) => [k, p.get(k)]));
}
